import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@morningstar/shared/environment';

@Injectable()
export class MaintenanceService {

  constructor(private httpClient: HttpClient) { }

  get(): Observable<any> {
    return this.httpClient.get<any>(`${environment.spaceGeekUrl}${environment.api.maintenance}`);
  }
}
